import { ChangeDetectorRef, Component } from '@angular/core';
import { Train } from 'src/app/models/train.model';

import { TrainService } from 'src/app/services/trains/trains.service';
import { Plant } from 'src/app/models/plant.model';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { Opdata } from 'src/app/models/opdata.model';
import { OpdataService } from 'src/app/services/opdata/opdata.service';
import {
  DataOutputModelCalc,
  OpdataCalc,
} from 'src/app/models/opdataCalc.model';
import { Unit } from 'src/app/models/unit.interface';
import { Stage } from 'src/app/models/role.model';
import { ActivatedRoute, Router } from '@angular/router';
import {
  PagingHeader,
  QueryStringParameters,
} from 'src/app/shared/shared.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-list-opdata',
  templateUrl: './list-opdata.component.html',
  styleUrls: ['./list-opdata.component.scss'],
})
export class ListOpdataComponent {
  public units: Array<Unit> = [
    { Id: 0, UnitName: 'Metric' },
    { Id: 1, UnitName: 'English' },
  ];

  queryParam: QueryStringParameters = new QueryStringParameters();
  pageHeaders: PagingHeader = new PagingHeader();
  config: any;
  sortDir = 1; //1= 'ASE' -1= DSC

  queryParamcalc: QueryStringParameters = new QueryStringParameters();
  pageHeaderscalc: PagingHeader = new PagingHeader();
  configcalc: any;
  sortDircalc = 1; //1= 'ASE' -1= DSC

  type: string =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

  public stages: Array<Stage> = [
    { Id: 1, Name: '1' },
    { Id: 2, Name: '2' },
    { Id: 3, Name: '3' },
    { Id: 4, Name: 'Total' },
  ];

  dtoptions: DataTables.Settings = {};
  dtoptions2: DataTables.Settings = {};
  trainDetails: Train = new Train();

  showDvUnit = false;
  showDownload = false;
  trains: Train[] = [];
  trainnew: Train[] = [];
  plants: Plant[] = [];
  opdata: Opdata[] = [];
  calcOpdata: OpdataCalc[] = [];
  allTrainList: Train[] = [];
  trainById: Train[] = [];
  opdataList: Opdata[] = [];
  calcOpdataList: OpdataCalc[] = [];
  showTable = true;
  showTableCalc = false;
  stages1 = false;
  stages2 = true;
  stages3 = true;
  total = true;
  SelectedId: string;
 
  newId: string;
  RawId: string;
  selectedPlantId: string;
  ShowTrainName = false;
  PlantId: string;
  trainId: string;
  ConvertedtrainId: number;
  convertedPlantId: number;
  OpdataCalcIds: number[] = [];

  opdataWithFlagD: Opdata[] = [];
  opdataWithFlagI: Opdata[] = [];

  showUndoBtn = false;

loggedInUserRole:string;
 loggedinUserId:string;
 plantAndUserId:string;

  //  constructor(
  //   private route: ActivatedRoute,
  //   private router: Router,
  //   private trainService: TrainService,
  //   private plantService: PlantsService,
  //   private opdataService: OpdataService,
  //   private cdref: ChangeDetectorRef,
  //   private toastr: ToastrService
  // ) {
  //   // Get data from route state instead of query params
  //   const navigation = this.router.getCurrentNavigation();
  //   const state = navigation?.extras?.state || history.state;

  //   if (state && state.trainId) {
  //     // Data from route state (primary source)
  //     this.PlantId = state.PlantId;
  //     this.selectedPlantId = state.PlantId;
  //     this.trainId = state.trainId;
  //     this.SelectedId = state.trainId;
  //     this.newId = this.SelectedId;
      
  //     console.log("Constructor - State received:", {
  //       PlantId: this.PlantId,
  //       trainId: this.trainId
  //     });
  //   }
    
  //   // Always check query params for pagination and filter parameters
  //   // OR as fallback for backward compatibility
  //   this.route.queryParams.subscribe((params) => {
  //     // Fallback: If no state, try to get from query params
  //     if (!state || !state.trainId) {
  //       if (params['PlantId']) {
  //         this.PlantId = atob(params['PlantId']!);
  //         this.selectedPlantId = atob(params['PlantId']!);
  //       }
  //       if (params['trainId']) {
  //         this.trainId = atob(params['trainId']!);
  //         this.SelectedId = atob(params['trainId']!);
  //         this.newId = this.SelectedId;
  //       }
  //       console.log("Constructor - Query params (fallback)");
  //     }
      
  //     // Apply pagination/filter query parameters (these can stay in URL)
  //     if (params['PageSize']) {
  //       this.queryParamcalc.PageSize = +params['PageSize'];
  //     }
  //     if (params['PageNumber']) {
  //       this.queryParamcalc.PageNumber = +params['PageNumber'];
  //     }
  //     if (params['MaxPageSize']) {
  //       this.queryParamcalc.MaxPageSize = +params['MaxPageSize'];
  //     }
  //     if (params['SearchQuery']) {
  //       this.queryParamcalc.SearchQuery = params['SearchQuery'];
  //     }
  //     if (params['OrderBy']) {
  //       this.queryParamcalc.OrderBy = params['OrderBy'];
  //     }
  //     if (params['OrderDir']) {
  //       this.queryParamcalc.OrderDir = params['OrderDir'];
  //     }
  //     if (params['SelectedValue']) {
  //       this.queryParamcalc.SelectedValue = params['SelectedValue'];
  //     }
  //   });
  // }
constructor(
  private route: ActivatedRoute,
  private router: Router,
  private trainService: TrainService,
  private plantService: PlantsService,
  private opdataService: OpdataService,
  private cdref: ChangeDetectorRef,
  private toastr: ToastrService
) {
  const navigation = this.router.getCurrentNavigation();
  const state = navigation?.extras?.state || history.state;

  if (state && state.trainId) {
    this.PlantId = state.PlantId;
    this.selectedPlantId = state.PlantId;
    this.trainId = state.trainId;
    this.SelectedId = state.trainId;
    this.newId = this.SelectedId;

    // Load query/pagination values from state
    if (state.queryParamcalc) {
      this.queryParamcalc = { ...state.queryParamcalc };
    }

    console.log("✅ Constructor - All data from state:", state);
  }

  
  this.route.queryParams.subscribe(params => {

    if (params['PlantId']) {
      this.PlantId = atob(params['PlantId']);
      this.selectedPlantId = this.PlantId;
    }

    if (params['trainId']) {
      this.trainId = atob(params['trainId']);
      this.SelectedId = this.trainId;
      this.newId = this.trainId;
    }

  });
}

  showstageone() {
    this.stages1 = false;
    this.stages2 = true;
    this.stages3 = true;
    this.total = true;
  }

  showstagetwo() {
    this.stages1 = true;
    this.stages2 = false;
    this.stages3 = true;
    this.total = true;
  }

  showstagethree() {
    this.stages1 = true;
    this.stages2 = true;
    this.stages3 = false;
    this.total = true;
  }

  showstagetotal() {
    this.stages1 = true;
    this.stages2 = true;
    this.stages3 = true;
    this.total = false;
  }

   masterSelected: boolean = false;
   
  selectednoOtherUser(calcId) {
    if (this.OpdataCalcIds.includes(calcId)) {
      let Index = this.OpdataCalcIds.indexOf(calcId);
      this.OpdataCalcIds.splice(Index, 1);
    } else {
      this.OpdataCalcIds.push(calcId);
    }
    console.log(this.OpdataCalcIds);

      // Update master checkbox if all rows are selected
  this.masterSelected = this.OpdataCalcIds.length === this.calcOpdataList.length;
  console.log(this.OpdataCalcIds);
  }

  
selectAllRows() {
  if (this.masterSelected) {
    this.OpdataCalcIds = this.calcOpdataList.map(x => x.Id);
  } else {
    this.OpdataCalcIds = [];
  }
  console.log(this.OpdataCalcIds);
}

isRowSelected(calcId: number): boolean {
  return this.OpdataCalcIds.includes(calcId);
}

  // selectednoOtherUser(calcId) {
  //   if (this.OpdataCalcIds.includes(calcId)) {
  //     let Index = this.OpdataCalcIds.indexOf(calcId);
  //     this.OpdataCalcIds.splice(Index, 1);
  //   } else {
  //     this.OpdataCalcIds.push(calcId);
  //   }
  //    console.log(this.OpdataCalcIds);
  // }

  navigate(TId){
    console.log(TId);
    var id = btoa(TId.toString())
    this.router.navigate(['/opdata/edit/' + id]);
  }

  softdelete() {
    console.log(this.OpdataCalcIds);
    const confirmDelete = confirm(
      'Are you sure you want to delete selected opdata?'
    );
    if (!confirmDelete) {
      return; 
    }
    
    this.opdataService
      .softDeleteModelForOpdataCalc(this.trainId, this.OpdataCalcIds)
      .subscribe({
        next: (List) => {
          this.toastr.error('Opdata deleted successfully!', 'Information');
          this.OpdataCalcIds= [];
          this.opdataService
            .getCalcOpdataByTrainIdNew(this.queryParamcalc, this.trainId)
            .subscribe((response: DataOutputModelCalc) => {
              this.calcOpdataList = response.Items;
              this.pageHeaderscalc = response.Paging;
            });
          this.getGetOPdatawithDflagById(this.trainId);
          this.getGetOPdatawithIflagById(this.trainId);
        },
      });
  }

  reloadPage() {
    window.location.reload();
  }

  Undo() {
    console.log(this.OpdataCalcIds);
    this.opdataService
      .opdataUndo(this.trainId)
      .subscribe((response: Response) => {
        if (response.statusText == 'Success') {
          this.toastr.success('opdata Undo successfully.', 'Information');
          this.OpdataCalcIds= [];
          this.opdataService
            .getCalcOpdataByTrainIdNew(this.queryParamcalc, this.trainId)
            .subscribe((response: DataOutputModelCalc) => {
              this.calcOpdataList = response.Items;
              this.pageHeaderscalc = response.Paging;
            });
          this.getGetOPdatawithDflagById(this.trainId);
          this.getGetOPdatawithIflagById(this.trainId);
        } else {
          (error) => {
            console.log('Error processing Undo of opdata:', error);
            this.OpdataCalcIds= [];
          };
        }
      });
  }

  gettrainsbyplantId(e) {
    this.SelectedId = e.target.value;
    console.log(e);
    this.selectedPlantId = this.SelectedId;
    this.PlantId = this.SelectedId;

    if(this.loggedInUserRole =='Standard User')
      {
      this.plantAndUserId = this.SelectedId + 'Z' + this.loggedinUserId;
          this.trainService.GetAccessibleTrainListByPlantId(this.plantAndUserId ).subscribe(
           
            (response: Train[]) => {
              this.allTrainList = response;
              console.log(this.allTrainList);
              
            },
      
            (error: any) => {
              console.log('error list');
            }
          );
      }
      else
      {
          this.trainService.getTrainByPlantId(this.SelectedId).subscribe(
        (response: Train[]) => {
        this.allTrainList = response;
        console.log(this.allTrainList);
        },
          (error: any) => {
            console.log('error list');
          }
        );
      }
  }
  getSelectedId(e: any) {
    this.SelectedId = e.target.value;
    this.newId = this.SelectedId;
    this.showDvUnit = true;
    this.showDownload = true;
    this.showTable = false;

    this.trainId = this.SelectedId;
    this.opdataService
      .getCalcOpdataByTrainIdNew(this.queryParamcalc, this.SelectedId)
      .subscribe((response: DataOutputModelCalc) =>
        {
          if(response.Items == null)
          {
            this.toastr.info('No opdata exist for selected train.', 'Information');
            this.calcOpdataList=[];
            this.pageHeaderscalc.TotalItems=0;
          }
          else
          {
            this.calcOpdataList = response.Items;
            this.pageHeaderscalc = response.Paging;
            console.log(this.calcOpdataList);

          }
      });

    this.trainService.getTrainById(this.SelectedId).subscribe({
      next: (response) => {
        this.trainDetails = response;
      },
    }); 
   // this.getGetOPdatawithDflagById(this.SelectedId);
   // this.getGetOPdatawithIflagById(this.SelectedId);


  }
  getTrainById(TrainId)
  {
    this.trainService.getTrainById(this.SelectedId).subscribe({
      next: (response) => {
        this.trainDetails = response;
      },
    });
  }

  getGetOPdatawithDflagById(TrainId) {
    this.opdataService.GetOPdatawithDflagById(TrainId).subscribe({
      next: (response) => {
        this.opdataWithFlagD = response;
      },
    });
  }

  getGetOPdatawithIflagById(TrainId) {
    this.opdataService.GetOPdatawithIflagById(TrainId).subscribe({
      next: (response) => {
        this.opdataWithFlagI = response;
      },
    });
  }

//   showRaw() {
//     this.showTableCalc = false;
//     this.showTable = true;
//     console.log(this.trainDetails.Id);
    
//     if (this.RawId != null) {
//       var id = btoa(this.trainDetails.Id.toString())
//       this.router.navigate([
//         '/trains/rawopdata/' + id,
//       ], {
//         queryParams: {
//           showselector: true,
//           PlantId: btoa(this.trainDetails.PlantId.toString()),
//           trainId: btoa(this.trainDetails.Id.toString()),
//           // Pass all queryParamcalc properties
//           MaxPageSize: this.queryParamcalc?.MaxPageSize,
//           SearchQuery: this.queryParamcalc?.SearchQuery,
//           PageNumber: this.queryParamcalc?.PageNumber,
//           PageSize: this.queryParamcalc?.PageSize,
//           OrderBy: this.queryParamcalc?.OrderBy,
//           OrderDir: this.queryParamcalc?.OrderDir,
//           SelectedValue: this.queryParamcalc?.SelectedValue
//         },
//       });
//     } else {
//       this.router.navigate(['/opdata/rawopdata'], {
//         queryParams: {
//           showselector: true,
//           PlantId: btoa(this.trainDetails.PlantId.toString()),
//           trainId: btoa(this.trainDetails.Id.toString()),
//           // Pass all queryParamcalc properties
//           MaxPageSize: this.queryParamcalc?.MaxPageSize,
//           SearchQuery: this.queryParamcalc?.SearchQuery,
//           PageNumber: this.queryParamcalc?.PageNumber,
//           PageSize: this.queryParamcalc?.PageSize,
//           OrderBy: this.queryParamcalc?.OrderBy,
//           OrderDir: this.queryParamcalc?.OrderDir,
//           SelectedValue: this.queryParamcalc?.SelectedValue
//         },
//         skipLocationChange: true,
//       });
//     }
// }

// new code 17/10/2025
showRaw() {
  this.showTableCalc = false;
  this.showTable = true;
  console.log(this.trainDetails.Id);

  const id = btoa(this.trainDetails.Id.toString());
  const stateData = {
    showselector: true,
    PlantId: this.trainDetails.PlantId,
    trainId: this.trainDetails.Id,
    MaxPageSize: this.queryParamcalc?.MaxPageSize,
    SearchQuery: this.queryParamcalc?.SearchQuery,
    PageNumber: this.queryParamcalc?.PageNumber,
    PageSize: this.queryParamcalc?.PageSize,
    OrderBy: this.queryParamcalc?.OrderBy,
    OrderDir: this.queryParamcalc?.OrderDir,
    SelectedValue: this.queryParamcalc?.SelectedValue,
  };

  if (this.RawId != null) {
    this.router.navigate(
      ['/trains/rawopdata/' + id],
      { state: stateData } 
    );
  } else {
    this.router.navigate(
      ['/opdata/rawopdata'],
      { state: stateData, skipLocationChange: true } 
    );
  }
}

  showCalc() {
    this.showTableCalc = true;
    this.showTable = false;
  }

  downloadexport(e) {
    this.opdataService.exportOpdata(e).subscribe(
      (respData) => {
        this.downLoadFile(respData, this.type, e);
      },
      (error) => {}
    );
  }

  /**
   * Method is use to download file from server.
   * @param data - Array Buffer data
   * @param type - type of the document.
   */
  downLoadFile(data: any, type: string, trainId: string) {
    var blob = new Blob([data], { type: type.toString() });
    var url = window.URL.createObjectURL(blob);
    //var pwa = window.open(url);
    var anchor = document.createElement('a');
    anchor.download = 'opdata-export-' + trainId + '.xlsx';
    anchor.href = url;
    anchor.click();
  }

  

  ngOnInit(): void {

  if (!this.queryParamcalc.PageSize) {
    this.queryParamcalc.PageSize = 10;
  }
  if (!this.queryParamcalc.PageNumber) {
    this.queryParamcalc.PageNumber = 1;
  }
  if (!this.queryParamcalc.MaxPageSize) {
    this.queryParamcalc.MaxPageSize = 10;
  }
  if (!this.queryParamcalc.SearchQuery) {
    this.queryParamcalc.SearchQuery = '';
  }
  
    this.configcalc = {
      currentPage: 1,
      itemsPerPage: this.queryParamcalc.PageSize,
    };

    this.showTable = true;


    if (this.PlantId != undefined) {
      this.calcdataloader();
    }

    console.log(this.PlantId);
    console.log(this.trainId);

    this.route.paramMap.subscribe({
      next: (params) => {
      const enId = params.get('id');
      const id = atob(params.get('id')!);
      if (enId != null) {
          this.newId = id;
          this.RawId = id;
          this.trainId = id;
          //this.getGetOPdatawithIflagById(id);
          //this.getGetOPdatawithDflagById(id);
          this.showUndoBtn = false;
          this.trainId = id;
          
          this.showTable = false;
          this.ShowTrainName = true;
          this.opdataService
            .getCalcOpdataByTrainIdNew(this.queryParamcalc, id)
            .subscribe((response: DataOutputModelCalc) => {
              this.calcOpdataList = response.Items;
              this.pageHeaderscalc = response.Paging;
            });

          this.trainService.getTrainById(id).subscribe({
            next: (response) => {
              // for showing selected plant and train from dashboard
              // this.plantService.setSelectedPlant(response.PlantId);
              // this.plantService.setSelectedTrain(response.Id);

              this.trainDetails = response;
              this.PlantId = this.trainDetails.PlantId.toString();
            },
          });

          this.showDvUnit = true;
          this.showDownload = true;
        
        } else {
          //this.getSelectedId(this.newId);

        if (this.newId) {
          this.getSelectedId({
            target: {
              value: this.newId
            }
          });
        }
        }
      },
    });

    this.dtoptions = {
      pagingType: 'full_numbers',
      order: [[0, 'desc']],
      
    };
    this.dtoptions2 = {
      pagingType: 'full_numbers',
      order: [[0, 'desc']],
    };
    this.showTableCalc = true;

    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    this.loggedInUserRole = loggedInuserRole.role;
    this.loggedinUserId = loggedInuserRole.userId;
    if(loggedInuserRole.role =='Standard User')
    {
      this.plantService.getPlantsByUserId(loggedInuserRole.userId)
      .subscribe({
        next: (plants)=>{
          this.plants = plants;
          this.plantService.setPlants(plants);   // IMPORTANT: Store plants in service for later use
        },
      })
      
    }
    else
    {
    this.plantService.getAllPlant().subscribe({
      next: (plants) => {
        this.plants = plants;
        this.plantService.setPlants(plants);
      },
      error: (response) => {
        console.log(response);
      },
    });
  }

    //    //load data using plantId from breadcrumbs
    // this.plantService.selectedPlant$.subscribe(plantId => {
    //   if (plantId) {
    //       this.gettrainsbyplantId({ target: { value: plantId } });
    //   }
    // });

    //        //load data using trainId from breadcrumbs
    // this.plantService.selectedTrain$.subscribe(trainId => {
    //   if (trainId) {
    //       this.getSelectedId({ target: { value: trainId } });
    //   }
    // });

// load data using plantId from breadcrumbs
this.plantService.selectedPlant$
.subscribe(plantId => {

  // Dashboard query load asel tar ignore
  if (
    plantId &&
    this.route.snapshot.queryParamMap.keys.length === 0 &&
    plantId.toString() !== this.PlantId
  ) {

    this.gettrainsbyplantId({
      target: {
        value: plantId
      }
    });

  }
});


// load data using trainId from breadcrumbs
this.plantService.selectedTrain$
.subscribe(trainId => {

  // Dashboard load ignore
  if (
    trainId &&
    this.route.snapshot.queryParamMap.keys.length === 0 &&
    trainId.toString() !== this.trainId
  ) {

    this.getSelectedId({
      target: {
        value: trainId
      }
    });

  }
});
    

  }

  // //added for remove infinity pagenation error from console
  // safePageSize(size: any): number {
  //   return size && size > 0 ? size : 10;
  // }

  // safePageNumber(page: any): number {
  //   return page && page > 0 ? page : 1;
  // }

  // safeTotalItems(total: any): number {
  //   return total || 0;
  // }

  calcdataloader() {
    this.plantService.getAllPlant().subscribe({
      next: (plants) => {
        this.plants = plants;
        this.plantService.setPlants(plants);   // IMPORTANT: Store plants in service for later use
      },
      error: (response) => {
        console.log(response);
      },
    });

    this.convertedPlantId = +this.PlantId;
    this.ConvertedtrainId = +this.trainId;

    this.showDvUnit = true;
    this.showDownload = true;
    this.showTable = false;

    this.trainService.getTrainByPlantId(this.PlantId).subscribe(
      (response: Train[]) => {
        this.allTrainList = response;
        console.log(this.allTrainList);
      },
      (error: any) => {
        console.log('error list');
      }
    );

    this.trainService.getTrainById(this.trainId).subscribe({
      next: (response) => {
        this.trainDetails = response;
      },
    });

    this.opdataService
      .getCalcOpdataByTrainIdNew(this.queryParamcalc, this.trainId)
      .subscribe((response: DataOutputModelCalc) => {
        this.calcOpdataList = response.Items;
        this.pageHeaderscalc = response.Paging;
        console.log(this.calcOpdataList);
       // this.getAPIResponse();
      });

    //this.getGetOPdatawithIflagById(this.trainId);
    //this.getGetOPdatawithDflagById(this.trainId);
  }

  getCalcdatalst() {
    if(this.newId==null)
    {
      this.newId=this.SelectedId;
    }
    this.opdataService
      .getCalcOpdataByTrainIdNew(this.queryParamcalc, this.newId)
      .subscribe((response: DataOutputModelCalc) => {
        this.calcOpdataList = response.Items;
        this.pageHeaderscalc = response.Paging;
      });
  }

  searchtable() {
    if (this.queryParamcalc.SearchQuery) {
      this.queryParamcalc.SearchQuery = this.queryParamcalc.SearchQuery.replace(/\//g, '-');
    }
    this.getCalcdatalst();
  }

  onPageChangecalc(newPage: number): void {
    this.queryParamcalc.PageNumber = newPage;
    this.getCalcdatalst();
  }

  // onPageSizeChangecalc(): void {
  //   this.queryParamcalc.PageSize = +this.queryParamcalc.PageSize;
  //   this.queryParamcalc.MaxPageSize = +this.queryParamcalc.PageSize;
  //   this.getCalcdatalst();
  // }
  onPageSizeChangecalc(): void {
  this.queryParamcalc.PageSize = +this.queryParamcalc.PageSize;
  this.queryParamcalc.MaxPageSize = +this.queryParamcalc.PageSize;
  
  const totalItems = this.pageHeaderscalc.TotalItems || 0;
  const maxValidPage = Math.ceil(totalItems / this.queryParamcalc.PageSize) || 1;

  if (this.queryParamcalc.PageNumber > maxValidPage) {
    this.queryParamcalc.PageNumber = 1;
  }
  
  this.getCalcdatalst();
}


  onSortClickcalc(event, columnname) {
    let target = event.currentTarget,
      classList = target.classList;

    if (classList.contains('fa-chevron-up')) {
      classList.remove('fa-chevron-up');
      classList.add('fa-chevron-down');
      this.sortDir = -1;
    } else {
      classList.add('fa-chevron-up');
      classList.remove('fa-chevron-down');
      this.sortDir = 1;
    }
    this.queryParamcalc.OrderBy = columnname;
    this.queryParamcalc.OrderDir = this.sortDir == -1 ? 'desc' : 'asc';
    this.getCalcdatalst();
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }
  getAPIResponse()
  {
    const start = performance. now(); 
    fetch('http://localhost:7135/swagger/index.html')
    console.log(start);
  }
}
